export default "__VITE_ASSET__OwQN_ehcd$a6YsxzYyGHsw__"